<div class="flex items-center gap-2 pb-2.5">
  <details class="dropdown dropdown-start shrink-0" #timelineConfig (toggle)="onTimelineConfigToggle()">
    <summary
      class="list-none btn btn-sm btn-outline rounded-lg indicator h-7 px-2"
      [ngClass]="
        timelineConfigOpened() || timelineConfigApplied()
          ? 'border-primary-purple-light bg-primary-purple-light-2'
          : 'border-gray-300 bg-neutrals-grey-01'
      "
    >
      @if (timelineConfigApplied()) {
        <span class="indicator-item h-2 w-2 rounded-full bg-primary-purple-light top-0.5 right-0.5"></span>
      }
      <img [src]="images.vehicles.configSchedule" [ngClass]="{'filter-primary-purple-light': timelineConfigOpened() || timelineConfigApplied()}" alt="timelineConfig" class="h-5 w-5" />
    </summary>
    <div tabindex="0" class="dropdown-content mt-2 z-50">
      @if (timelineConfigOpened()) {
        <app-vehicle-timeline-config
          [viewMode]="viewMode()"
          [visibleHours]="visibleHours()"
          [visibleDays]="visibleDays()"
          (applyEventEmitter)="onApplyTimelineVisibility($event)"
          (closeEventEmitter)="closeTimelineConfig()"
        ></app-vehicle-timeline-config>
      }
    </div>
  </details>
  <div #periodStrip class="flex min-w-0 flex-1 items-center gap-2 overflow-x-auto scroll-smooth" (scroll)="onPeriodStripScroll()">
    @for (period of periods(); track period.label; let i = $index) {
      <button
        class="btn btn-sm shrink-0 whitespace-nowrap rounded-lg h-7"
        [ngClass]="
          selectedPeriodIndex() === i
            ? 'btn-outline border-primary-purple-light bg-primary-purple-light-2 text-primary-purple-light'
            : 'border border-neutrals-grey-02 bg-neutrals-white text-neutrals-grey-04'
        "
        (click)="selectPeriod(i)"
      >
        {{ period.label }}
      </button>
    }
  </div>
</div>

<div
  #timelineScroll
  class="isolate overflow-auto rounded-lg border border-neutrals-grey-02 bg-neutrals-white"
  style="max-height: calc(100vh - 15rem)"
  (scroll)="onTimelineScroll()"
  (pointerdown)="onTimelineScrollPointerDown($event)"
>
  <div #timelineContent class="relative" [class.smooth-width]="zooming()" [style.width.px]="vehicleColumnWidth + timelineWidth()">
    <div class="sticky top-0 z-30 flex border-b border-neutrals-grey-02 bg-neutrals-grey-01">
      <div
        class="sticky left-0 z-10 shrink-0 border-r border-neutrals-grey-02 bg-neutrals-grey-01"
        [style.width.px]="vehicleColumnWidth"
      ></div>
      <div
        class="timeline-hours relative flex h-8 select-none items-center"
        [ngClass]="dragging() ? 'cursor-grabbing' : 'cursor-grab'"
        [style.width.px]="timelineWidth()"
        (pointerdown)="startHeaderDrag($event)"
        (pointermove)="moveHeaderDrag($event)"
        (pointerup)="endHeaderDrag()"
        (pointercancel)="endHeaderDrag()"
      >
        @for (column of columns(); track column.startMinutes) {
          <div
            class="smooth-width h-full shrink-0 truncate text-xs font-medium leading-8 flex items-center border-r bg-neutrals-grey-01"
            [ngClass]="[
              column.outside ? 'text-neutrals-grey-04 border-neutrals-grey-01' : 'text-neutrals-grey-06 border-neutrals-grey-02',
              column.collapsed ? 'bg-neutrals-grey-03 justify-center border-neutrals-grey-03' : 'pl-1',
              column.boundary ? 'border-r-2 border-neutrals-grey-03' : ''
            ]"
            [style.width.px]="column.width"
            [tooltip]="column.collapsed ? collapsedTooltip(column) : ''"
            [position]="TooltipPosition.BELOW"
            [visibleTooltip]="column.collapsed"
          >
            @if (column.collapsed) {
              <img [src]="images.visibilityOff" class="w-5 h-5" />
            }
            @else {
              {{ column.label }}
            }
          </div>
        }
        @if (!isWeekMode()) {
          <span class="absolute right-1 text-xs font-medium text-neutrals-grey-04">{{ utilsService.minutesToTime(axisEndMinutes()) }}</span>
        }
      </div>
    </div>

    @for (row of rows(); track $index; let rowIndex = $index) {
      @let schedule = row.schedule;
      @let incompatibleRowReason = incompatibleRowReasons()[$index];
      <div
        class="flex border-b border-gray-100 last:border-b-0 motion-safe:transition-opacity focus-visible:outline-2 focus-visible:outline-primary-purple"
        [class.opacity-40]="incompatibleRowReason"
        [attr.data-row-id]="schedule.id"
        [id]="'schedule-row-' + schedule.id"
        #scheduleRow
        tabindex="-1"
        (pointerenter)="onRowPointerEnter(row, $event)"
      >
        @if (row.collapsed) {
          <button
            type="button"
            class="block w-full cursor-pointer bg-neutrals-grey-01 hover:bg-primary-purple-light-2 focus-visible:outline-2 focus-visible:outline-primary-purple motion-safe:transition-colors"
            [style.height.px]="row.height"
            [attr.aria-label]="row.expandLabel"
            [attr.aria-expanded]="false"
            [attr.aria-controls]="'schedule-row-' + schedule.id"
            [tooltip]="row.expandLabel!"
            [position]="TooltipPosition.BELOW_RIGHT"
            [tooltipAnchor]="collapsedRowStart"
            (click)="expandRow(schedule.id!)"
          >
            <span #collapsedRowStart class="sticky left-0 block h-full" [style.width.px]="vehicleColumnWidth"></span>
          </button>
        } @else {
        <div
          class="selectable-row sticky left-0 z-20 flex shrink-0 items-center border-r border-neutrals-grey-02 bg-neutrals-white px-4 font-semibold cursor-pointer"
          [class.selected-row]="schedule.id === selectedRowId()"
          [ngClass]="schedule.active ? 'text-neutrals-grey-06' : 'text-neutrals-grey-04'"
          [style.width.px]="vehicleColumnWidth"
          (click)="onClickRow(schedule.id!)"
        >
          <span
            class="truncate"
            [id]="`vehicle-${schedule.name}-${$index}`"
            [tooltip]="`${schedule.name}`"
            [visibleTooltip]="utilsService.visibleTooltip(`vehicle-${schedule.name}-${$index}`)"
          >{{ schedule.name }}</span>
          @if (incompatibleRowReason) {
            <span class="sr-only">{{ literalService.get(incompatibleRowReason, true) }}</span>
          }
          <button
            class="pointer-events-none absolute left-0 top-1/2 flex h-6 w-6 -translate-y-1/2 items-center justify-center rounded border border-primary-purple-light bg-primary-purple-light-2 opacity-0 focus-visible:opacity-100 focus-visible:outline-2 focus-visible:outline-primary-purple"
            [attr.aria-label]="row.collapseLabel"
            [attr.aria-expanded]="true"
            [attr.aria-controls]="'schedule-row-' + schedule.id"
            [tooltip]="row.collapseLabel!"
            (click)="collapseRow(schedule.id!, $event)"
          >
            <img [src]="images.vehicles.collapseRow" alt="" aria-hidden="true" class="h-4 w-4 filter-primary-purple-light" />
          </button>
        </div>
        <div class="relative" [style.width.px]="timelineWidth()" [style.height.px]="row.height">
          <div class="absolute inset-0 flex">
            @for (column of columns(); track column.startMinutes) {
              <div
                class="smooth-width shrink-0"
                [ngClass]="{
                  'border-r-2 border-neutrals-grey-03': !column.collapsed && column.boundary,
                  'border-r border-dashed border-neutrals-grey-02': !column.collapsed && !column.boundary
                }"
                [style.width.px]="column.width"
              ></div>
            }
          </div>
          @for (block of row.blocks; track block.key; let blockIndex = $index) {
            @let availability = block.availability;
            @let palette = blockPalette(availability);
            @let availabilitySelected = isAvailabilitySelected(availability);
            @let availabilityInRow = inAssignedRow(availability, schedule.id);
            @let changed = availabilityChanged(availability) && availabilityInRow;
            @let feedback = dragFeedback();
            @let availabilityDragged = isDragged(availability);
            <div
              class="schedule-item absolute select-none px-0 pt-4"
              [ngClass]="{
                'cursor-pointer': availabilityInRow,
                'rounded-l': !block.squaredStart,
                'rounded-r': !block.squaredEnd,
                'ring-2 ring-primary-purple-light': feedback?.targetAvailabilityId === availability.id,
                'z-1': changed && !availabilitySelected,
                'z-2': availabilitySelected,
                'bg-primary-purple-light-2': availabilitySelected,
                'availability-hoverable': !availabilitySelected && availabilityInRow,
                'availability-hidden': !availabilitiesShown()
              }"
              [class.smooth-block]="zooming()"
              [class.opacity-40]="dimmedBlocks()?.[rowIndex]?.[blockIndex]"
              [style.left.px]="block.left"
              [style.width.px]="block.width"
              [style.top.px]="block.top"
              [style.height.px]="block.height"
              [style.background-color]="blockBackground(palette, availabilitySelected, availabilityInRow)"
              [style.--block-hover]="palette.blockHover"
              [attr.data-availability-id]="availability.id"
              (pointerdown)="availabilityInRow && startItemDrag($event, availability)"
              (click)="availabilityInRow && openEditor($event, availability)"
            >
              @if (availabilityDragged && block.labelled) {
                <span class="pointer-events-none absolute -top-5 left-0 whitespace-nowrap rounded bg-neutrals-grey-06 px-1 text-[10px] font-bold text-neutrals-white">
                  {{ feedback?.label }}
                </span>
              }
              @if (block.labelled && availabilitiesShown()) {
                <span
                  class="absolute left-1.5 right-0 top-0.5 overflow-hidden whitespace-nowrap text-[10px] leading-3 font-bold"
                  [class.text-primary-purple-light]="availabilitySelected"
                  [class.opacity-70]="!availabilityInRow"
                  [style.color]="availabilitySelected ? null : palette.label"
                  [ngClass]="{'opacity-70': !availabilityInRow}"
                >
                  {{ utilsService.minutesToTime(toMinutes(availability.startDateTime)) }} - {{ utilsService.minutesToTime(toMinutes(availability.endDateTime)) }}
                </span>
              }
              <div class="relative" [style.height.px]="block.tripsHeight">
                @for (chip of block.trips; track chip.trip.id) {
                  @let trip = chip.trip;
                  @let tripSelected = isTripSelected(trip);
                  @let tripEdited = tripChanged(availability, trip);
                  @let tripDragged = isDragged(availability, trip);
                  <div
                    class="schedule-item absolute cursor-pointer select-none overflow-hidden"
                    [ngClass]="{
                      'rounded-l': !chip.squaredStart,
                      'rounded-r': !chip.squaredEnd,
                      'outline-primary-purple-light': tripEdited || tripSelected,
                      'outline-3': tripEdited,
                      'outline': tripSelected && !tripEdited,
                      'ring-2 ring-secondary-red': tripDragged && feedback?.invalid,
                      'z-3': !tripSelected,
                      'z-4': tripSelected
                    }"
                    [class.smooth-block]="zooming()"
                    [style.left.px]="chip.left"
                    [style.width.px]="chip.width"
                    [style.top.px]="chip.top"
                    [style.height.px]="chip.height"
                    [attr.data-trip-id]="trip.id"
                    (pointerdown)="startItemDrag($event, availability, trip)"
                    (click)="openEditor($event, availability, trip)"
                  >
                    @if (tripDragged) {
                      <span class="pointer-events-none absolute -top-5 left-0 whitespace-nowrap rounded bg-neutrals-grey-06 px-1 text-[10px] font-bold text-neutrals-white">
                        {{ feedback?.label }}
                      </span>
                    }
                    @if (chip.compact) {
                      <div
                        class="h-full min-w-1"
                        [ngClass]="{ 'rounded-l-sm': !chip.squaredStart, 'rounded-r-sm': !chip.squaredEnd, 'bg-primary-purple-light-2': tripSelected, 'trip-hoverable': !tripSelected }"
                        [style.background-color]="tripSelected ? null : palette.chip"
                        [style.--chip-hover]="palette.chipHover"
                      ></div>
                    } @else {
                      <div
                        class="flex h-full min-w-0 items-center gap-1 px-1.5 text-xs font-semibold"
                        [ngClass]="{
                          'rounded-l': !chip.squaredStart,
                          'rounded-r': !chip.squaredEnd,
                          'bg-primary-purple-light-2 text-primary-purple-light': tripSelected,
                          'text-white trip-hoverable': !tripSelected
                        }"
                        [style.background-color]="tripSelected ? null : palette.chip"
                        [style.--chip-hover]="palette.chipHover"
                      >
                        <span>{{ availability.service?.tag }}</span>
                        <img
                          [src]="blockChipImage()"
                          alt=""
                          class="h-3 w-3 shrink-0"
                          [ngClass]="{ 'filter-primary-purple-light': tripSelected, 'chip-icon': !tripSelected }"
                        />
                        <span [id]="`chip-${block.key}-${trip.id}`" class="truncate" [tooltip]="`${chipLabel(trip)}`" [visibleTooltip]="utilsService.visibleTooltip(`chip-${block.key}-${trip.id}`)">{{ chipLabel(trip) }}</span>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
            @if ((availabilitySelected || changed) && availabilitiesShown() && !availabilityDragged && droppedAvailabilityId() !== availability.id) {
              <div
                class="pointer-events-none absolute z-5 outline-primary-purple-light"
                [ngClass]="{
                  'rounded-l': !block.squaredStart,
                  'rounded-r': !block.squaredEnd,
                  'outline-3': changed,
                  'outline': !changed
                }"
                [class.smooth-block]="zooming()"
                [style.left.px]="block.left"
                [style.width.px]="block.width"
                [style.top.px]="block.top"
                [style.height.px]="block.height"
                [attr.data-availability-outline-id]="availability.id"
              ></div>
            }
          }
          @if (loadingSpan(); as span) {
            @let skeletonRow = skeletonLayout[$index % skeletonLayout.length];
            <div
              class="pointer-events-none absolute inset-y-0 z-6 bg-neutrals-white"
              data-loading-span
              [style.left.px]="span.left"
              [style.width.px]="span.width"
            >
              @for (block of skeletonRow; track $index) {
                <div class="absolute inset-y-[5%]" [style.left.px]="block.start * span.width" [style.width.px]="block.width * span.width">
                  <ngx-skeleton-loader class="block h-full" count="1" appearance="line" [theme]="{ 'height': '100%', 'width': '100%', 'margin-bottom': '0', 'border-radius': '6px' }" />
                </div>
              }
            </div>
          }
        </div>
        }
      </div>
    }

    @if (loading()) {
      @for (row of skeletonRows(); track $index) {
        <div class="flex border-b border-gray-100 last:border-b-0">
          <div
            class="sticky left-0 z-20 flex shrink-0 items-center border-r border-neutrals-grey-02 bg-neutrals-white px-4"
            [style.width.px]="vehicleColumnWidth"
          >
            <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'height': '16px', 'width': '72px', 'margin-bottom': '0' }" />
          </div>
          <div class="relative min-h-16" [style.width.px]="timelineWidth()">
            @for (block of row; track $index) {
              <div
                class="absolute inset-y-[5%]"
                [style.left.px]="block.start * timelineWidth()"
                [style.width.px]="block.width * timelineWidth()"
              >
                <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'height': '56px', 'width': '100%', 'margin-bottom': '0', 'border-radius': '6px' }" />
              </div>
            }
          </div>
        </div>
      }
    }

    @for (column of collapsedColumns(); track column.startMinutes) {
      <div
        class="pointer-events-none absolute bottom-0 top-8 z-10 bg-neutrals-grey-03"
        [class.smooth-left]="zooming()"
        [style.left.px]="vehicleColumnWidth + column.left"
        [style.width.px]="column.width"
      ></div>
    }

    @if (nowLineOffset() !== null) {
      <div
        class="bg-primary-purple-light pointer-events-none absolute bottom-0 top-8 z-10 w-0.5"
        [class.smooth-left]="zooming()"
        [style.left.px]="vehicleColumnWidth + nowLineOffset()!"
      ></div>
    }
  </div>
  @if (pendingChanges().length) {
    <div class="action-buttons absolute right-12 bottom-12 flex gap-4 z-50">
      <button class="cancel flex items-center gap-2 px-4 py-3 bg-neutrals-white rounded-full shadow-lg cursor-pointer hover:bg-gray-50 transition" (click)="discardChanges()">
        <img [src]="images.close" alt="discard" class="h-4 w-4 filter-secondary-red" />
        <span class="font-semibold text-sm text-secondary-red">{{ literalService.get('discard', true) }}</span>
      </button>
      <button class="save flex items-center gap-2 px-4 py-3 bg-neutrals-white rounded-full shadow-lg cursor-pointer hover:bg-gray-50 transition" (click)="saveChanges()">
        <img [src]="images.check" alt="commit" class="h-4 w-4 filter-secondary-green" />
        <span class="font-semibold text-sm text-secondary-green">{{ literalService.get('makeChanges', true) }}</span>
      </button>
    </div>
  }
</div>
@if (hoveredRow(); as hovered) {
  <button
    class="absolute left-0 z-40 flex h-6 w-6 -translate-x-1/2 -translate-y-1/2 cursor-pointer items-center justify-center rounded border border-primary-purple-light bg-primary-purple-light-2 hover:bg-primary-purple-light/20"
    tabindex="-1"
    aria-hidden="true"
    [style.top.px]="hovered.top"
    [tooltip]="hovered.label"
    (click)="collapseRow(hovered.id, $event)"
  >
    <img [src]="images.vehicles.collapseRow" alt="" aria-hidden="true" class="h-4 w-4 filter-primary-purple-light" />
  </button>
}
<app-vehicle-schedule-save-modal [changes]="changeList()" (summaryClosedEventEmitter)="onScheduleSummaryClosed()" />

@if (editTarget(); as target) {
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="target.origin"
    [cdkConnectedOverlayOpen]="true"
    [cdkConnectedOverlayPositions]="editorPositions"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayViewportMargin]="8"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    (backdropClick)="closeEditor()"
    (detach)="closeEditor()"
  >
    <app-vehicle-schedule-edit-modal
      [availability]="target.availability"
      [clientIds]="clientIds()"
      [trip]="target.trip"
      [findAvailability]="findTripAvailability"
      [conflicts]="pendingConflicts()"
      [conflictsOnly]="!!pendingEdit()?.dropped"
      [proposedEdit]="proposedEdit()"
      [checking]="checkingConflicts() || checkingTarget()"
      (confirmConflictsEventEmitter)="confirmConflicts()"
      (cancelConflictsEventEmitter)="cancelConflicts()"
      (saveEventEmitter)="onSaveEdit($event)"
      (assignmentChangeEventEmitter)="checkTripTarget($event)"
      (closeEventEmitter)="closeEditor()"
    ></app-vehicle-schedule-edit-modal>
  </ng-template>
}
